export default "__VITE_ASSET__BvTjyzzR__"